import { getCurrentUser } from "./session";

const API_BASE = (
  process.env.REACT_APP_GOOURHUB_BUSINESS_API ||
  "https://business-api.goourhub.com"
).replace(/\/+$/, "");

let cachedNotificationToken = "";
let cachedUntil = 0;
let cachedSessionToken = "";

/*
 * Exchange the normal GoOurHub session token for the
 * short-lived token accepted by the Notification API.
 */
async function getNotificationToken() {
  const session = getCurrentUser();

  const sessionToken =
    String(session?.token || "").trim();

  if (!sessionToken) {
    throw new Error("Sign in required.");
  }

  /*
   * If the user signed out/in or switched accounts,
   * never reuse the previous notification token.
   */
  if (
    cachedSessionToken &&
    cachedSessionToken !== sessionToken
  ) {
    cachedNotificationToken = "";
    cachedUntil = 0;
  }

  cachedSessionToken = sessionToken;

  if (
    cachedNotificationToken &&
    Date.now() < cachedUntil
  ) {
    return cachedNotificationToken;
  }

  const response = await fetch(
    `${API_BASE}/api/auth/notification-token`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${sessionToken}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Notification sign-in failed (${response.status}).`
    );
  }

  const data = await response.json();

  const notificationToken =
    String(
      data?.notificationToken || ""
    ).trim();

  if (!notificationToken) {
    throw new Error(
      "Notification token was not returned."
    );
  }

  const expiresIn =
    Number(data?.expiresIn) || 900;

  /*
   * Refresh about 30 seconds before actual expiration.
   */
  cachedNotificationToken =
    notificationToken;

  cachedUntil =
    Date.now() +
    Math.max(60, expiresIn - 30) * 1000;

  return notificationToken;
}

async function notificationRequest(
  path,
  options = {}
) {
  const token =
    await getNotificationToken();

  const response = await fetch(
    `${API_BASE}${path}`,
    {
      ...options,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Notification request failed (${response.status}).`
    );
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
}

/*
 * Returns:
 * {
 *   notifications: [...],
 *   unread_count: number
 * }
 */
export async function getNotifications() {
  return notificationRequest(
    "/api/notifications"
  );
}

export async function getUnreadNotificationCount() {
  return notificationRequest(
    "/api/notifications/unread-count"
  );
}

export function clearNotificationTokenCache() {
  cachedNotificationToken = "";
  cachedSessionToken = "";
  cachedUntil = 0;
}
export async function archiveNotification(id) {
  if (!id) {
    return null;
  }

  return notificationRequest(
    `/api/notifications/${id}/archive`,
    {
      method: "PATCH",
    }
  );
}